"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentFileMock = void 0;
const uuid_1 = require("uuid");
const attachment_file_model_1 = require("./attachment-file.model");
const enums_1 = require("../../enums");
class AttachmentFileMock extends attachment_file_model_1.AttachmentFile {
    constructor(data) {
        const id = (0, uuid_1.v4)();
        const name = AttachmentFileMock.generateRandomFileName();
        const type = AttachmentFileMock.generateRandomFileType();
        const size = AttachmentFileMock.generateRandomFileSize();
        const seedData = {
            id,
            name,
            size,
            type,
            createdAt: Date.now(),
            allowedTypeList: Object.values(enums_1.AttachmentFileType),
            metadata: {},
            ...data,
        };
        super(seedData);
    }
    static generateRandomFileName() {
        const prefixes = ['MPRS', 'CERT', 'DOC', 'FORM', 'ROUTE', 'PROFILE', 'CHECKLIST'];
        const types = ['CERT', 'REPORT', 'PLAN', 'APPROVAL', 'REFERENCE', 'MANUAL'];
        const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];
        const type = types[Math.floor(Math.random() * types.length)];
        return `${prefix}_${type}`;
    }
    static generateRandomFileType() {
        const fileTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];
        return fileTypes[Math.floor(Math.random() * fileTypes.length)];
    }
    static generateRandomFileSize() {
        // Generate a random file size between 100KB and 10MB
        return Math.floor(Math.random() * 10000000) + 100000;
    }
}
exports.AttachmentFileMock = AttachmentFileMock;
